/** @file editLock: why the playhead's frame cannot take a viewport edit (no clip, mirrored half), or null. */
import type { EditorState } from '../../state/editorTypes';
import { mirrorStart } from '../timeline/mirrorStart';

/** The reasons, as the viewport writes them where the gizmo would be. */
const EDIT_LOCKS = {
  noClip: 'no clip picked — pick one on the timeline',
  mirrored: 'mirrored half (computed) — edit the other side',
} as const;

/**
 * `noClip` without a document clip at the playhead; `mirrored` on a `mirrorHalf` clip's computed half (frames from
 * `mirrorStart` on, the rule `mirrorGuard` applies); null when the frame can be keyed. No toast (read every frame).
 */
export function editLock(s: Pick<EditorState, 'playhead' | 'puppet'>): string | null {
  const name = s.playhead.clip;
  const clip = name === null ? undefined : s.puppet.doc?.clips[name];
  if (clip === undefined) return EDIT_LOCKS.noClip;
  const start = mirrorStart(clip);
  return start !== null && s.playhead.frame >= start ? EDIT_LOCKS.mirrored : null;
}
